/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddExchangeAccountRequest } from '../models/AddExchangeAccountRequest';
import type { ExchangeAccountListResponse } from '../models/ExchangeAccountListResponse';
import type { ExchangeAccountResponse } from '../models/ExchangeAccountResponse';
import type { jmt_api__routes__exchange_accounts__SimpleResponse } from '../models/jmt_api__routes__exchange_accounts__SimpleResponse';
import type { VerifyResponse } from '../models/VerifyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ExchangeAccountsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Exchange Accounts
     * @returns ExchangeAccountListResponse Successful Response
     * @throws ApiError
     */
    public listExchangeAccounts({
        includeRevoked = false,
    }: {
        includeRevoked?: boolean,
    }): CancelablePromise<ExchangeAccountListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/exchange-accounts',
            query: {
                'include_revoked': includeRevoked,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Exchange Account
     * Verify the key at the exchange, then store it. Never the other way round.
     * @returns ExchangeAccountResponse Successful Response
     * @throws ApiError
     */
    public addExchangeAccount({
        requestBody,
    }: {
        requestBody: AddExchangeAccountRequest,
    }): CancelablePromise<ExchangeAccountResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/exchange-accounts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke Exchange Account
     * Soft revoke. The row stays — `deployments` references it and history has to survive.
     *
     * 404 for another account's id, and 404 for one already revoked: both answers are "there
     * is nothing here to revoke", and distinguishing them would confirm the id exists.
     * @returns jmt_api__routes__exchange_accounts__SimpleResponse Successful Response
     * @throws ApiError
     */
    public revokeExchangeAccount({
        exchangeAccountId,
    }: {
        exchangeAccountId: number,
    }): CancelablePromise<jmt_api__routes__exchange_accounts__SimpleResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/v1/exchange-accounts/{exchange_account_id}',
            path: {
                'exchange_account_id': exchangeAccountId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Exchange Account
     * Re-ask the exchange what this stored key can do, and record the answer.
     *
     * `Rule 1`'s third enforcement point — "exchanges occasionally change what a key grants,
     * and a permission acquired silently is worse than one granted deliberately". The monthly
     * job will call this; the button in the UI calls the same thing.
     * @returns VerifyResponse Successful Response
     * @throws ApiError
     */
    public verifyExchangeAccount({
        exchangeAccountId,
    }: {
        exchangeAccountId: number,
    }): CancelablePromise<VerifyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/exchange-accounts/{exchange_account_id}/verify',
            path: {
                'exchange_account_id': exchangeAccountId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
